// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog-popup-toggle-options-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.dialog-popup-toggle-options-section-label {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
}

.dialog-popup-toggle-options-section-title {
  font-size: var(--ui-font-md);
  font-weight: 600;
  color: #374151;
}

.dialog-popup-toggle-options-section-description {
  font-size: var(--ui-font-sm);
  color: #6b7280;
  line-height: 1.4;
}

.dialog-popup-toggle-options-options {
  display: grid;
  grid-template-columns: repeat(1, minmax(150px, 1fr));
  gap: 0.375rem;
  padding: 0.75rem;
  background: #f8fafc;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  overflow-y: scroll;
  max-height: 200px;
  overflow-x: hidden;
}

.dialog-popup-toggle-options-toggle-option {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.dialog-popup-toggle-options-toggle-option-header {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  cursor: pointer;
  padding: 0.375rem 0.5rem;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.dialog-popup-toggle-options-toggle-option-header:hover {
  background: rgba(36, 154, 251, 0.234);
}

.dialog-popup-toggle-options-checkbox {
  width: 16px;
  height: 16px;
  border: 2px solid #d1d5db;
  border-radius: 4px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.dialog-popup-toggle-options-option-text {
  font-size: var(--ui-font-md);
  color: #374151;
  line-height: 1.4;
}

.dialog-popup-toggle-options-toggle-icon {
  margin-left: auto;
  color: #068cd9;
  transition: all 0.2s ease;
}

.dialog-popup-toggle-options-toggle-controls {
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 0.5rem;
  padding: 0.5rem 0.5rem;
  background: white;
  border-radius: 8px;
  border: 1px solid #249efb;
  animation: slideDown 0.2s ease-out;
}

.dialog-popup-toggle-options-toggle-state {
  padding: 0.25rem 0.5rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: var(--ui-font-sm);
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.dialog-popup-toggle-options-toggle-state.active {
  background: #0b9bf5;
  color: white;
}

.dialog-popup-toggle-options-toggle-state:hover:not(.active) {
  background: #c7f8fe;
  color: #068fd9;
}

.dialog-popup-toggle-options-toggle-switch {
  display: flex;
  align-items: center;
}

.dialog-popup-toggle-options-toggle-switch-button {
  position: relative;
  width: 44px;
  height: 24px;
  background: #e5e7eb;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.dialog-popup-toggle-options-toggle-switch-button.active {
  background: #0ba3f5;
}

.dialog-popup-toggle-options-toggle-switch-slider {
  position: absolute;
  top: 2px;
  left: 2px;
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.dialog-popup-toggle-options-toggle-switch-button.active .dialog-popup-toggle-options-toggle-switch-slider {
  transform: translateX(20px);
}

.dialog-popup-toggle-options-toggle-state {
  padding: 0.25rem 0.5rem;
  border: none;
  background: transparent;
  color: #6b7280;
  font-size: var(--ui-font-sm);
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.dialog-popup-toggle-options-toggle-state.active {
  background: #0b9bf5;
  color: white;
}

.dialog-popup-toggle-options-toggle-state:hover:not(.active) {
  background: #c7f8fe;
  color: #068fd9;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 300px;
  }
}

@media (max-width: 360px) {
  .dialog-popup-toggle-options-options {
    grid-template-columns: 1fr;
    gap: 0.25rem;
    padding: 0.5rem;
  }

  .dialog-popup-toggle-options-toggle-controls {
    flex-direction: column;
    gap: 0.5rem;
    align-items: stretch;
  }
}

@media (max-width: 550px) {
  .dialog-popup-toggle-options-toggle-switch {
    align-self: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DialogPopup/DialogPopupToggleOptions/DialogPopupToggleOptions.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oDAAoD;EACpD,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,4BAA4B;EAC5B,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,WAAW;IACX,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".dialog-popup-toggle-options-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n}\n\n.dialog-popup-toggle-options-section-label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n}\n\n.dialog-popup-toggle-options-section-title {\n  font-size: var(--ui-font-md);\n  font-weight: 600;\n  color: #374151;\n}\n\n.dialog-popup-toggle-options-section-description {\n  font-size: var(--ui-font-sm);\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.dialog-popup-toggle-options-options {\n  display: grid;\n  grid-template-columns: repeat(1, minmax(150px, 1fr));\n  gap: 0.375rem;\n  padding: 0.75rem;\n  background: #f8fafc;\n  border-radius: 12px;\n  border: 1px solid #e2e8f0;\n  overflow-y: scroll;\n  max-height: 200px;\n  overflow-x: hidden;\n}\n\n.dialog-popup-toggle-options-toggle-option {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.dialog-popup-toggle-options-toggle-option-header {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  padding: 0.375rem 0.5rem;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.dialog-popup-toggle-options-toggle-option-header:hover {\n  background: rgba(36, 154, 251, 0.234);\n}\n\n.dialog-popup-toggle-options-checkbox {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #d1d5db;\n  border-radius: 4px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n}\n\n.dialog-popup-toggle-options-option-text {\n  font-size: var(--ui-font-md);\n  color: #374151;\n  line-height: 1.4;\n}\n\n.dialog-popup-toggle-options-toggle-icon {\n  margin-left: auto;\n  color: #068cd9;\n  transition: all 0.2s ease;\n}\n\n.dialog-popup-toggle-options-toggle-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  gap: 0.5rem;\n  padding: 0.5rem 0.5rem;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid #249efb;\n  animation: slideDown 0.2s ease-out;\n}\n\n.dialog-popup-toggle-options-toggle-state {\n  padding: 0.25rem 0.5rem;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: var(--ui-font-sm);\n  font-weight: 500;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.dialog-popup-toggle-options-toggle-state.active {\n  background: #0b9bf5;\n  color: white;\n}\n\n.dialog-popup-toggle-options-toggle-state:hover:not(.active) {\n  background: #c7f8fe;\n  color: #068fd9;\n}\n\n.dialog-popup-toggle-options-toggle-switch {\n  display: flex;\n  align-items: center;\n}\n\n.dialog-popup-toggle-options-toggle-switch-button {\n  position: relative;\n  width: 44px;\n  height: 24px;\n  background: #e5e7eb;\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.dialog-popup-toggle-options-toggle-switch-button.active {\n  background: #0ba3f5;\n}\n\n.dialog-popup-toggle-options-toggle-switch-slider {\n  position: absolute;\n  top: 2px;\n  left: 2px;\n  width: 20px;\n  height: 20px;\n  background: white;\n  border-radius: 50%;\n  transition: all 0.2s ease;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.dialog-popup-toggle-options-toggle-switch-button.active .dialog-popup-toggle-options-toggle-switch-slider {\n  transform: translateX(20px);\n}\n\n.dialog-popup-toggle-options-toggle-state {\n  padding: 0.25rem 0.5rem;\n  border: none;\n  background: transparent;\n  color: #6b7280;\n  font-size: var(--ui-font-sm);\n  font-weight: 500;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.dialog-popup-toggle-options-toggle-state.active {\n  background: #0b9bf5;\n  color: white;\n}\n\n.dialog-popup-toggle-options-toggle-state:hover:not(.active) {\n  background: #c7f8fe;\n  color: #068fd9;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 300px;\n  }\n}\n\n@media (max-width: 360px) {\n  .dialog-popup-toggle-options-options {\n    grid-template-columns: 1fr;\n    gap: 0.25rem;\n    padding: 0.5rem;\n  }\n\n  .dialog-popup-toggle-options-toggle-controls {\n    flex-direction: column;\n    gap: 0.5rem;\n    align-items: stretch;\n  }\n}\n\n@media (max-width: 550px) {\n  .dialog-popup-toggle-options-toggle-switch {\n    align-self: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
